export default {
  operationRecord: {
    title: "歷史記錄",
    totalData: "條數據",
    totalPrefix: "共計",
    onlyKeyStep: "只展示關鍵步驟",
  },
  historyRecode: {
    loading: "拼命加載中",
    headers: {
      name: "名稱",
      updateTime: "更新時間",
      operation: "操作",
    },
    empty: "暫無數據",
    more: "更多",
    messages: {
      deleteConfirm: "此操作將永久刪除該文件, 是否繼續?",
      deleteConfirmTitle: "刪除確認",
      confirmButton: "確定",
      cancelButton: "取消",
      cancelKeyStep: "取消關鍵步驟!",
      addKeyStep: "已加入關鍵步驟!",
      editSuccess: "修改成功",
      deleteSuccess: "刪除成功",
      cancelDelete: "已取消刪除",
    },
  },
};
